import React from 'react'
import {Nav, Navbar, NavbarBrand} from 'react-bootstrap'
import styled from 'styled-components'

const Styles = styled.div`
    .navbar {
        background-color: #98eb34;
    }

    .navbar-brand, .navbar-nav .nav-link {
        color: #8080FF;

        &:hover {
            color: #F1E7D6;
        }
    }
    `;

export const NavigationBar = () => (
    <Styles>
        <Navbar expand="lg">
            <Navbar.Brand href="/"><img width="65" src="logo.png"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse id='basic-navbar-nav'>
                <Nav variant="pills" defaultActiveKey="/">
                    <Nav.Item><Nav.Link href="/">Home</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href="/data">Data</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href="/news">News</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href="/about">About</Nav.Link></Nav.Item>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    </Styles>
)